const SIZES = { sm: 14, md: 20, lg: 32 } as const

export function Spinner({ size = "md" }: { size?: keyof typeof SIZES }) {
  const px = SIZES[size]
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label="Cargando"
      style={{ animation: "mc-spin 0.8s linear infinite" }}
    >
      <circle cx="12" cy="12" r="10" stroke="var(--border-default)" strokeWidth="3" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="var(--brand-primary)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <style>{`@keyframes mc-spin { to { transform: rotate(360deg); } }`}</style>
    </svg>
  )
}
